import styles from './ChallengeSettings.module.scss';
import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { getChallengeSettings, setChallengeSettings } from '../../../api/settings';
import { FullTimeScoreTable } from '../components/FullTimeScoreTable/FullTimeScoreTable';
import { settingsList } from '../../../const/challenge-setttings-list';

export const ChallengeSettings = () => {
  const [settings, setSettings] = useState(settingsList);
  const [isCanSubmit, setIsCanSubmit] = useState(false);
  const [isMount, setIsMount] = useState(false);
  
  useEffect(() => {
    (async () => {
      const currentSettingsList = await getChallengeSettings();
      if (currentSettingsList.length > 0) {
        const updatedSettingsList = settings.map((item) => {
          const settingsItem = currentSettingsList.find((setting: any) => setting.key === item.key);
          
          if (settingsItem) {
            return {
              ...item,
              key: settingsItem.key,
              data: { ...item.data, ...settingsItem.data },
              id: settingsItem.id
            }
          }
          return item;
        });
        
        setSettings(updatedSettingsList);
        handleValidateForm(updatedSettingsList);
      }
      
      setIsMount(true);
    })()
  }, []);
  
  const handleValidateForm = (newSettingsList: any) => {
    const validValues = newSettingsList.map((item: any) => {
      return (Number(item.data.value) > 0 && item.data.energyPrice !== '' && Number(item.data.energyPrice) >= 0)
        || Number(item.data.minutesToAddOneEnergy) > 0;
    });
    
    const isInvalidValue = validValues.includes(false);
    setIsCanSubmit(!isInvalidValue);
  };
  
  const handleChangeCoefficients = (
    { newCoefficients, coefficientsId}: { newCoefficients: number; coefficientsId: string }
  ) => {
    const newSettingsList = settings.map((item) => {
      if (item.key === 'ENERGY_ACCRUALS') {
        return {...item, data: {minutesToAddOneEnergy: newCoefficients.toString()}}
      }
      
      if (item.key === coefficientsId) {
        return {...item, data: {...item.data, value: newCoefficients.toString()}}
      }
      
      return item;
    })
  
    setSettings(newSettingsList);
    handleValidateForm(newSettingsList);
  };
  
  const handleChangeEnergyPrice = (
    { newPrice, coefficientsId}: { newPrice: number; coefficientsId: string }
  ) => {
    const newSettingsList = settings.map((item) => {
      if (item.key === coefficientsId) {
        return {...item, data: {...item.data, energyPrice: newPrice.toString()}}
      }
      
      return item;
    })
  
    setSettings(newSettingsList);
    handleValidateForm(newSettingsList);
  };
  
  const handleSave = async () => {
    await setChallengeSettings(settings);
  };
  
  const handleChangeFullTimeCoefficient =
    (updatedCoefficientsTable: { score: string, coefficient: number }[],
     defaultFrequencyCoefficient: number) => {
      const updatedSettingsList = settings.map((item) => {
        if (item.key === 'FINAL_SCORE') {
          return {
            ...item,
            data: { ...item.data, frequencies: updatedCoefficientsTable, defaultFrequencyCoefficient },
          }
        }
        return item;
      });
  
      const validValues = updatedCoefficientsTable.map((item: any) => Number(item.coefficient) > 0);
  
      const isInvalidValue = validValues.includes(false);
      
      setIsCanSubmit(!isInvalidValue);
      setSettings(updatedSettingsList);
  };
  
  return (
    <div>
      <div className={styles.header}>
        Here you can set the coefficients for sub-challenges
      </div>
      <div>
        {isMount && settings.map((item, index) => (
          <div className={styles.coefficientsItem} key={index.toString()}>
            <span className={styles.challengeName}>{item.challengeName}</span>
            {item.key !== 'ENERGY_ACCRUALS' && (
              <>
                <div className="flex">
                  <TextField
                    error={!(Number(item.data.value) > 0)}
                    id={item.id}
                    label={item.label}
                    variant="outlined"
                    value={item.data.value}
                    type="number"
                    className={styles.coefficientsInput}
                    onChange={(e) =>
                      handleChangeCoefficients({ newCoefficients: Number(e.target.value), coefficientsId: item.key})
                    }
                    helperText={!(Number(item.data.value) > 0) ? "Must be a number greater than 0" : " "}
                  />
                  <TextField
                    error={!(Number(item.data.energyPrice) >= 0)}
                    id={`${item.key}_energy_price`}
                    label="Energy price"
                    variant="outlined"
                    value={item.data.energyPrice}
                    type="number"
                    className={styles.coefficientsInput}
                    onChange={(e) =>
                      handleChangeEnergyPrice({ newPrice: Number(e.target.value), coefficientsId: item.key})
                    }
                    helperText={!(Number(item.data.energyPrice) >= 0) ? "Must be a positive number" : ""}
                  />
                </div>
                {item.key === 'FINAL_SCORE' && (
                  <FullTimeScoreTable data={item.data} handleChangeCoefficient={handleChangeFullTimeCoefficient} />
                )}
              </>
            )}
            {item.key === 'ENERGY_ACCRUALS' && (
              <div>
                <TextField
                  error={!(Number(item.data.minutesToAddOneEnergy) > 0)}
                  id={item.id}
                  label={item.label}
                  variant="outlined"
                  value={item.data.minutesToAddOneEnergy}
                  type="number"
                  className={styles.coefficientsInput}
                  onChange={(e) =>
                    handleChangeCoefficients({ newCoefficients: Number(e.target.value), coefficientsId: item.key})
                  }
                  helperText={!(Number(item.data.value) > 0) ? "Must be a number greater than 0" : " "}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-10">
        <Button onClick={handleSave} className="!py-3 !px-10" variant="contained" disabled={!isCanSubmit}>
          Save
        </Button>
      </div>
    </div>
  )
}